import Service from '@ember/service';
import { tracked } from '@glimmer/tracking';

export default class RevisionKeyService extends Service {
  @tracked key;
}
